import { c as _c } from "react/compiler-runtime";
import './section-content.scss';
import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';
import { ItemCardSkeleton } from '@sola/ark-core/molecules/item-card/item-card.tsx';
import { TooltipInfo } from '@sola/ark-core/molecules/tooltip-info/tooltip-info.tsx';
type SectionContentHeadingProps = {
  isLoadingHeading: true;
  heading?: never;
  subheading?: never;
  tooltipContent?: never;
} | {
  isLoadingHeading?: false;
  heading: string;
  subheading?: string | React.ReactNode;
  tooltipContent?: string;
};
type SectionContentContentProps = {
  isLoadingContent: true;
  children?: React.ReactNode;
} | {
  isLoadingContent?: false;
  children: React.ReactNode;
};
export type SectionContentProps = SectionContentHeadingProps & SectionContentContentProps;

/**
 * Section for Card Lists.
 * In the future, we may want to make this more composable depending on our needs.
 */
export const SectionContent: React.FC<SectionContentProps> = t0 => {
  const $ = _c(18);
  const {
    children,
    heading,
    tooltipContent,
    subheading,
    isLoadingHeading,
    isLoadingContent
  } = t0;
  let t1;
  if ($[0] !== heading || $[1] !== isLoadingHeading || $[2] !== subheading || $[3] !== tooltipContent) {
    t1 = !isLoadingHeading && <><div className="flex items-center label-potent label-md gap-snug-lg label-neutral-mild"><h2 className="label-potent label-md label-neutral-mild">{heading}</h2>{tooltipContent && <TooltipInfo triggerClassName="SectionContent__tticon" contentClassName="label-md lg:label-lg" alignOffset={-12} onPointerDownOutside={_temp}>{tooltipContent}</TooltipInfo>}</div>{subheading && <span className="label-moderate label-lg label-neutral-amplified">{subheading}</span>}</>;
    $[0] = heading;
    $[1] = isLoadingHeading;
    $[2] = subheading;
    $[3] = tooltipContent;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== isLoadingHeading) {
    t2 = isLoadingHeading && <Skeleton height={50} />;
    $[5] = isLoadingHeading;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div className="SectionContent__labels mb-comfy-xl lg:mb-none shrink-0">{t1}{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== children || $[11] !== isLoadingContent) {
    t4 = isLoadingContent ? <ItemCardSkeleton /> : children;
    $[10] = children;
    $[11] = isLoadingContent;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t4) {
    t5 = <div className="SectionContent__content w-full flex flex-col gap-comfy-xs">{t4}</div>;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t3 || $[16] !== t5) {
    t6 = <section className="SectionContent max-w-md lg:flex lg:items-start lg:flex-row lg:justify-between lg:gap-comfy-xl">{t3}{t5}</section>;
    $[15] = t3;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
function _temp(e) {
  e.preventDefault();
}